import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import ImageTag from "../../component/reusebale/imageTag";
import { ArrowLeft } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import PrevShiftChat from "../../component/past-shift/PrevShiftChat";
import ShiftInbox from "../../component/past-shift/shiftInbox";
import Info from "../../component/past-shift/info";
import ShiftStatus from "../../component/past-shift/PrevShiftStatus";
import BaseUrl from "../../constants/BaseUrl";
import * as AuthAction from "../../store/actions/auth/AuthAction";

const DetailShift = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { loginSuccess } = useSelector((state) => state.auth);

  const sessionIdPastShift = useSelector(
    (state) => state.data.sessionIdPastShift
  );
  const [chats, setChats] = useState([]);

  // Check authentication state
  useEffect(() => {
    const initializeDetailShift = async () => {
      if (!loginSuccess) {
        if (AuthAction.hasValidLoginCredentials()) {
          await dispatch(AuthAction.HydrateStateAction());
        } else {
          navigate("/login");
        }
      }
    };

    initializeDetailShift();
  }, [dispatch, navigate, loginSuccess]);

  const GetAllChats = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getCompltedChatSessionsBySessionId/${sessionIdPastShift}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setChats(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const GetAllTechnicalChats = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getTechnicalCompltedChatSessionsBySessionId/${sessionIdPastShift}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setChats(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    if (loginSuccess.user.type === "technical") {
      GetAllTechnicalChats();
    } else {
      GetAllChats();
    }
  }, [sessionIdPastShift]);

  const [selectedChatId, setSelectedChatId] = useState();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const { selectedSessionId } = useSelector((state) => state.data);

  return (
    <div className="w-[95%] mx-auto h-screen flex flex-col justify-between">
      <div className="h-[15%] 2xl:h-[13%] flex items-center">
        <div className="w-[25%] flex justify-center items-center">
          <div
            className="flex justify-center items-center mr-3 bg-white w-9 h-9 rounded-full cursor-pointer"
            onClick={() => navigate("/view-profile")}
          >
            <ArrowLeft className="text-themeColor" size={20} strokeWidth={2} />
          </div>
          <div onClick={() => navigate("/support-chat")}>
            <ImageTag
              path="/assets/logo.png"
              classes="w-[200px] object-cover cursor-pointer"
              altText="logo"
            />
          </div>
        </div>
        <div className="w-[75%]">
          <div
            className="flex justify-end items-center relative"
            ref={dropdownRef}
          >
            <div>
              <p className="font-popinsMedium text-xs text-darkColor/60">
                Welcome
              </p>
              <p className="font-popinsSemiBold text-base text-darkColor">
                {`${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName} `}
              </p>
            </div>
            <div onClick={toggleMenu}>
              <ImageTag
                path="/assets/daashboard/user/user.png"
                classes="size-[50px] rounded-full cursor-pointer ml-2"
                altText="logo"
              />
            </div>

            {isOpen && (
              <div className="absolute z-20 right-0 top-14 mt-2 w-48 bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 font-popinsMedium text-sm">
                <ul className="py-2">
                  <li
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => navigate("/view-profile")}
                  >
                    View Profile
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => navigate("/reset-password")}
                  >
                    Change Password
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => navigate("/login")}
                  >
                    Logout
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="h-[84%] 2xl:h-[86%] w-full flex flex-col justify-between">
        <div className="h-[35%] 2xl:h-[30%] flex">
          {/* <div className="w-[60%]">
            <Info />
          </div> */}
          <div className="w-full">
            <ShiftStatus />
          </div>
        </div>
        <div className="h-[63%] 2xl:h-[68%] flex">
          <div className="w-[25%] h-full">
            <PrevShiftChat
              chatId={selectedChatId}
              onChatSelect={(id) => {
                setSelectedChatId(id);
              }}
              chats={chats}
            />
          </div>
          <div className="w-[75%] pl-6 h-full overflow-scroll scrollbar-hide panelScroll">
            {selectedChatId ? (
              <ShiftInbox chatId={selectedChatId} />
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailShift;
